/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchQueryDocumentList } from '../../models/search-query-document-list';

export interface SearchQueryGetSearchQueryDocumentList$Params {

/**
 * GUID of the search query
 */
  searchQueryId: string;

/**
 * Requested document count. Value must be less than or equal to 255
 */
  count?: number;
}

export function searchQueryGetSearchQueryDocumentList(http: HttpClient, rootUrl: string, params: SearchQueryGetSearchQueryDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchQueryDocumentList>> {
  const rb = new RequestBuilder(rootUrl, searchQueryGetSearchQueryDocumentList.PATH, 'get');
  if (params) {
    rb.path('searchQueryId', params.searchQueryId, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchQueryDocumentList>;
    })
  );
}

searchQueryGetSearchQueryDocumentList.PATH = '/search-query/{searchQueryId}/document/list';
